import { render, staticRenderFns } from "./vehicle_route_history.vue?vue&type=template&id=28dcb7c2&scoped=true&"
import script from "./vehicle_route_history.vue?vue&type=script&lang=js&"
export * from "./vehicle_route_history.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_route_history.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./vehicle_route_history.vue?vue&type=style&index=1&id=28dcb7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcb7c2",
  null
  
)

export default component.exports